import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, TextArea } from 'components/common/form';

import type { ButtonCategory } from 'components/common/Button';
import type { AccessRequestObj } from 'components/common/accessRequest/AccessRequests';
import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  action: 'accept' | 'deny';
  isBatchAction: boolean;
  id?: number;
  isDropdown?: boolean;
  onSubmit: ({ action, id, message }: AccessRequestObj) => Promise<void>;
  requests?: number;
}

const AccessRequestsAction = ({
  action,
  isBatchAction,
  id,
  isDropdown = false,
  onSubmit,
  requests
}: Props) => {
  const { messages } = useReduxState();

  let actionText: string;
  let buttonCategory: ButtonCategory;
  let buttonIcon: IconProp;
  let title: string;
  if (action === 'accept') {
    actionText = getMessageWithPlaceholders({
      message: messages.courseAccessRequestActionAcceptConfirmText,
      placeholders: { numberOfRequests: requests }
    });
    buttonCategory = 'success';
    buttonIcon = 'check-circle';
    title = isBatchAction
      ? messages.courseAccessRequestActionAcceptAll
      : messages.courseAccessRequestActionAccept;
  } else {
    actionText = getMessageWithPlaceholders({
      message: messages.courseAccessRequestActionDenyConfirmText,
      placeholders: { numberOfRequests: requests }
    });
    buttonCategory = 'danger';
    buttonIcon = 'ban';
    title = isBatchAction
      ? messages.courseAccessRequestActionDenyAll
      : messages.courseAccessRequestActionDeny;
  }

  const handleSubmit = async (values: { adminMessage: string }) => {
    await onSubmit({ action, id, message: values.adminMessage });
  };

  return (
    <ModalButtonWithForm
      buttonCategory={buttonCategory}
      buttonDisabled={requests === 0}
      buttonIcon={buttonIcon}
      buttonIsDropdown={isDropdown}
      buttonSize="header"
      buttonText={title}
      modalActionText={messages.commonConfirm}
      modalTitle={title}
      onSubmit={handleSubmit}
    >
      {() => (
        <>
          {isBatchAction ? (
            <div style={{ fontSize: '1.5rem' }}>{actionText}</div>
          ) : null}

          <FormGroup
            label={`${messages.commonMessage} (${messages.commonOptional})`}
          >
            <TextArea field="adminMessage" id={`adminMessage-${id || 0}`} />
          </FormGroup>
        </>
      )}
    </ModalButtonWithForm>
  );
};

export default AccessRequestsAction;
